import * as React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export default function MultiSelectSearch(props) {
  const [value, setValue] = React.useState(props.selectedValues ? props.selectedValues : []);

  React.useEffect(() => {
    if (props.selectedValues !== undefined) {
      setValue(props.selectedValues)
    }
  }, [props.selectedValues])

  return (
    <Autocomplete
      readOnly={props.readOnly ? true : false}
      autoComplete
      autoHighlight
      autoSelect
      multiple
      options={props.optionsArray}
      getOptionLabel={(option) => option[props.labelKey]}
      value={value}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={props.label}
          placeholder={props.label}
        />
      )}
      onChange={(event, values) => {
        setValue(values)
        props.onSelected(values)
      }}
    />
  );
}